import OrderSummaryView from './order-summary-view'

export default OrderSummaryView
